// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__cCZQq","vLegacy":"SelectSecondary_vLegacy__1AUL5","error":"SelectSecondary_error__3v4FB","disabled":"SelectSecondary_disabled__lju1b"};